import { useState, useEffect } from 'react'
export default function useWpJson (url) {
  const [jsonResponse, setPosts] = useState([])
  useEffect(() => {
    async function loadPosts () {
      const fetchUrl = `/wp-json/wp/v2/${url}`
      const response = await fetch(fetchUrl)
      if (!response.ok) {
        // oups! something went wrong
        return
      }

      const posts = await response.json()
      setPosts(posts)
    }

    loadPosts()
  }, [url])
  return jsonResponse
}
